import { defer, of, asyncScheduler } from 'rxjs';
import { delay, take, repeat, concatMap } from 'rxjs/operators';
import { randomNumberGenerator } from '../utils/numberGenerator';
export var randomTimer = function (min, max, generator, scheduler) {
    if (generator === void 0) { generator = randomNumberGenerator; }
    if (scheduler === void 0) { scheduler = asyncScheduler; }
    return defer(function () {
        var index = 0;
        return defer(function () { return of(index++); }).pipe(concatMap(function (value) { return of(value).pipe(delay(generator(min, max), scheduler)); }), take(1), repeat());
    });
};
//# sourceMappingURL=randomTimer.js.map